import React, {useState, useEffect, useContext} from 'react';
import makeTitle from 'function/makeTitle.js';

import {SectionTitle, ListPortfolio} from 'components/items';
import {BtnWithIconAndText, BtnIcon} from 'components/btns';
import {PortfolioPreview} from 'components/section';

import iconArrowLeft from 'image/ic_arrow_left.svg';
import iconArrowRight from 'image/ic_arrow_right.svg';


// firebase
import firebase from 'library/firebase-config';
import 'firebase/firestore';
import { authContext } from 'shared/App';
const db = firebase.firestore();
const COLLECTION = "portfolio";

const sectionTitle = [
  {
    text: "OUR",
    color: "defualt",
    break: false
  },{
    text: "PORTFOLIO",
    color: "main",
    break: true
  }
]

const Portfolio = (props) => {
  const {setIsPfLoading} = useContext(authContext);
  const [portfolioArr, setportfolioArr] = useState([]);
  const [stylePortfolio, setStylePortfolio] = useState({});
  const [portfolioCount, setPortfolioCount] = useState(0);
  const [portfolioWidth, setPortfolioWidth] = useState(25);
  const [nowIndex, setNowIndex] = useState(null);

  useEffect(() => {
    const initData = async () => {
      setIsPfLoading(true);
      setportfolioArr(await _get());
      setIsPfLoading(false);
    }
    initData();

    checkWindowWidth();
    window.addEventListener('resize', checkWindowWidth)
  }, [setIsPfLoading])
  
  useEffect(()=> {
    setStylePortfolio({
      width: `${portfolioArr.length*portfolioWidth}%`,
      left: `-${portfolioCount*portfolioWidth}%`
    })
  }, [portfolioArr, portfolioCount, portfolioWidth]);

  const _get = async () => {
    try{
      const ref = await db.collection(COLLECTION).orderBy('timestamp', 'desc').limit(5).get();
      
      let result = [];
      ref.forEach(el => {
        result.push({
          ...el.data(),
          id: el.id
        })
      })
      return result;
    }
    catch(e){
      console.log(e);
    }
    
  }

  const checkWindowWidth = () => {
    if(window.innerWidth<768){
      setPortfolioWidth(60);
    }else{
      setPortfolioWidth(25);
    }
  }

  const handleClickArrow = (e) => {
    if(e.target.classList[1] === "btn-arrowLeft"){
      if(portfolioCount>0)
      setPortfolioCount(portfolioCount-1);
    }else{
      if(portfolioCount<portfolioArr.length-4)
      setPortfolioCount(portfolioCount+1);
    }
  }

  const handleCloseClick = () => {
    setNowIndex(null);
  }
  
  const handleListClick = (index) => {
    setNowIndex(index);
  }

  const drawPortfolio = () => {
    return portfolioArr.map((el, index) => {
      return <ListPortfolio key = {el.id} el = {el} handleListClick = {handleListClick} index = {index}/>
    })
  }

  const handleNextImageClick = () => {
    setNowIndex(nowIndex+1);
  }
  const handlePrevImageClick = () => {
    setNowIndex(nowIndex-1);
  }

  return (
    <section className = {`Portfolio ${props.className}`}>
      <div className="section-header">
        <div className="con">
          <SectionTitle text = {makeTitle(sectionTitle)}  type = "center"/>
        </div>
      </div>

      <div className="section-contents">
        <div className="con">
          <div className="wrap-arrowBtns">
            <BtnIcon image = {iconArrowLeft} name = "iconArraowLeft" className = "btn-arrowLeft" onClick = {handleClickArrow}/>
            <BtnIcon image = {iconArrowRight} name = "iconArrowRight"  className = "btn-arrowRight" onClick = {handleClickArrow}/>
          </div>

          <div className="wrap-List">
            
            <ul className = "portfolio wrap-slidList" style = {stylePortfolio}>
              {drawPortfolio()}
            </ul>
          </div>
        </div>

        <BtnWithIconAndText text = "포트폴리오 더보기" to = "./portfolio" className = "btn-portfolio right" icon = {iconArrowRight}/>
      </div>

      {portfolioArr[0]&&nowIndex!==null
      ? <PortfolioPreview handleCloseClick = {handleCloseClick} handleNextImageClick = {handleNextImageClick} handlePrevImageClick = {handlePrevImageClick} nowIndex = {nowIndex} data = {portfolioArr} />
      : ''}
    </section>
  );
}

export default Portfolio;